import React, { useState } from 'react'
import LoginModal from '@src/components/modals/LoginModal'
import TeacherLoginModal from '@src/components/modals/TeacherLoginModal'
import SignupModal from '@src/components/modals/SignupModal'
import LanguageChooserModal from '@src/components/modals/LanguageChooserModal'
import ResetPasswordModal from '@src/components/modals/ResetPasswordModal'
import ParentLoginModal from '@src/components/modals/ParentLoginModal'
import TeacherSignupModal from '@src/components/modals/TeacherSignupModal'
import ParentSignupModal from '@src/components/modals/ParentSignupModal'
import SchoolLeaderSignupModal from '@src/components/modals/SchoolLeaderSignupModal'
import WhatIsACodeModal from '@src/components/modals/WhatIsACodeModal'
import SchoolLeaderLoginModal from './SchoolLeaderLoginModal'
import VideoModal from './VideoModal'
import SummerKindnessModal from '@src/components/modals/SummerKindnessModal'

enum ModalType {
  LanguageChooser,
  Login,
  Signup,
  ResetPassword,
  TeacherLogin,
  TeacherSignup,
  ParentLogin,
  ParentSignup,
  SchoolLeaderLogin,
  SchoolLeaderSignup,
  WhatIsACode,
  VideoModal,
  SummerKindnessModal
}

type ModalsState = {
  modal?: ModalType
  props?: any
}

type ModalContextType = ModalsState & {
  showModal: (ModalType, any?) => void
  hideModal: () => void
}

const ModalContext = React.createContext<ModalContextType>({
  showModal: () => null,
  hideModal: () => null
})

const ModalProvider = ({ children }) => {
  const [modalsState, setModalsState] = useState<ModalsState>({})

  return (
    <ModalContext.Provider
      value={{
        ...modalsState,
        showModal: (modal, props = {}) => {
          setModalsState({
            props,
            modal
          })
        },
        hideModal: () =>
          setModalsState({
            modal: null,
            props: {}
          })
      }}
    >
      {children}
    </ModalContext.Provider>
  )
}

const ModalRoot = () => (
  <ModalContext.Consumer>
    {({ modal, props, hideModal }) => (
      <>
        {modal === ModalType.TeacherLogin && <TeacherLoginModal {...props} closeModal={hideModal}/>}
        {modal === ModalType.TeacherSignup && <TeacherSignupModal {...props} closeModal={hideModal}/>}
        {modal === ModalType.ParentLogin && <ParentLoginModal {...props} closeModal={hideModal}/>}
        {modal === ModalType.ParentSignup && <ParentSignupModal {...props} closeModal={hideModal}/>}
        {modal === ModalType.Login && <LoginModal {...props} closeModal={hideModal}/>}
        {modal === ModalType.Signup && <SignupModal {...props} closeModal={hideModal}/>}
        {modal === ModalType.SchoolLeaderSignup && <SchoolLeaderSignupModal {...props} closeModal={hideModal}/>}
        {modal === ModalType.ResetPassword && <ResetPasswordModal {...props} closeModal={hideModal}/>}
        {modal === ModalType.LanguageChooser && <LanguageChooserModal {...props} closeModal={hideModal}/>}
        {modal === ModalType.WhatIsACode && <WhatIsACodeModal {...props} closeModal={hideModal}/>}
        {modal === ModalType.SchoolLeaderLogin && <SchoolLeaderLoginModal {...props} closeModal={hideModal}/>}
        {modal === ModalType.VideoModal && <VideoModal {...props} closeModal={hideModal}/>}
        {modal === ModalType.SummerKindnessModal && <SummerKindnessModal {...props} closeModal={hideModal}/>}
      </>
    )}
  </ModalContext.Consumer>
)

export { ModalProvider, ModalRoot, ModalContext, ModalType }
